var dispatchEvent = function (phase, info) {
    var eventName = "squire-http-request-".concat(phase);
    try {
        var event_1 = new CustomEvent(eventName, { detail: info });
        window.dispatchEvent(event_1);
    }
    catch (e) {
        // Do nothing, just don't dispatch event
    }
};
export var notifyRequestStart = function (info) {
    dispatchEvent('start', info);
};
export var notifyRequestSuccess = function (info) {
    dispatchEvent('success', info);
};
export var notifyRequestError = function (info) {
    dispatchEvent('error', info);
};
export var downloadFromBlob = function (blob, fileName) {
    var blobUrl = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
};
